// NACE Rev. 2 codes relevant to healthcare-services and healthcare-IT.
// National variants (SNI in SE, SBI in NL, NACEBEL in BE, EMTAK in EE, DB07 in DK)
// follow NACE Rev. 2 at the four-digit level with minor extensions.
//
// We track the four-digit code; per-country adapters normalise their national
// codes back to the canonical NACE Rev. 2 form at ingestion time.

export const HEALTHCARE_SERVICES_NACE = {
  PRIMARY_CARE: '86.21',
  SPECIALIST_MEDICAL: '86.22',
  DENTAL: '86.23',
  OTHER_HUMAN_HEALTH: '86.90',
  RESIDENTIAL_NURSING: '87.10',
  RESIDENTIAL_SOCIAL_CARE: '88.10',
  VETERINARY: '75.00',
  OPTICAL_RETAIL: '47.78',
  MEDICAL_ORTHO_RETAIL: '47.74',
} as const;

export const HEALTHCARE_SERVICES_NACE_CODES = Object.values(
  HEALTHCARE_SERVICES_NACE,
) as readonly string[];

// Generic IT / professional codes — used as a prefilter for the healthcare-IT
// classifier. Membership in these codes is necessary but not sufficient:
// the combined classifier additionally requires healthcare-domain signals
// in the company name, description, website, or director profiles.
export const HEALTHCARE_IT_PREFILTER_NACE = {
  COMPUTER_PROGRAMMING: '62.01',
  IT_CONSULTING: '62.02',
  COMPUTER_FACILITIES_MANAGEMENT: '62.03',
  OTHER_IT_SERVICES: '62.09',
  DATA_PROCESSING: '63.11',
  WEB_PORTALS: '63.12',
  OTHER_PROFESSIONAL_SCIENTIFIC: '74.90',
} as const;

export const HEALTHCARE_IT_PREFILTER_CODES = Object.values(
  HEALTHCARE_IT_PREFILTER_NACE,
) as readonly string[];

export const ALL_PHASE_1_NACE_CODES = [
  ...HEALTHCARE_SERVICES_NACE_CODES,
  ...HEALTHCARE_IT_PREFILTER_CODES,
] as readonly string[];
